<div class="card m-6">
    <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">Viagens</h2>
        <p-button 
            label="Adicionar" 
            icon="pi pi-plus" 
            (onClick)="navigateToCreate()" 
            severity="success" />
    </div>

    <!-- Filtros -->
    <div class="mb-4 p-4 bg-gray-50 rounded-lg">
        <div class="flex justify-between items-center mb-3">
            <h3 class="text-lg font-semibold">Filtros</h3>
            <p-button 
                label="Limpar Filtros" 
                icon="pi pi-filter-slash" 
                severity="secondary"
                size="small"
                (onClick)="clearFilters()" />
        </div>
        
        <!-- Primeira linha: Motorista, Cidade Origem, Cidade Destino -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <!-- Filtro por Motorista -->
            <div>
                <label for="driverFilter" class="block text-sm font-medium mb-2">Motorista</label>
                <p-select 
                    id="driverFilter"
                    [(ngModel)]="driverId"
                    [options]="drivers"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Selecione um motorista"
                    [showClear]="true"
                    (onChange)="onDriverChange($event.value)"
                    class="w-full" />
            </div>

            <!-- Filtro por Cidade de Origem -->
            <div>
                <label for="fromCityFilter" class="block text-sm font-medium mb-2">Cidade de Origem</label>
                <p-select 
                    id="fromCityFilter"
                    [(ngModel)]="fromCityId"
                    [options]="cities"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Selecione a origem"
                    [showClear]="true"
                    (onChange)="onFromCityChange($event.value)"
                    class="w-full" />
            </div>

            <!-- Filtro por Cidade de Destino -->
            <div>
                <label for="toCityFilter" class="block text-sm font-medium mb-2">Cidade de Destino</label>
                <p-select 
                    id="toCityFilter"
                    [(ngModel)]="toCityId"
                    [options]="cities"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Selecione o destino"
                    [showClear]="true"
                    (onChange)="onToCityChange($event.value)"
                    class="w-full" />
            </div>
        </div>

        <!-- Segunda linha: Status, Data Início, Data Fim -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <!-- Filtro por Status -->
            <div>
                <label for="statusFilter" class="block text-sm font-medium mb-2">Status</label>
                <p-select 
                    id="statusFilter"
                    [(ngModel)]="status"
                    [options]="statusOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione o status"
                    [showClear]="true"
                    (onChange)="onStatusChange($event.value)"
                    class="w-full" />
            </div>

            <!-- Filtro por Data Início -->
            <div>
                <label for="startDateFilter" class="block text-sm font-medium mb-2">Data Início</label>
                <p-datepicker 
                    id="startDateFilter"
                    [(ngModel)]="startDate"
                    placeholder="Selecione a data início"
                    [showClear]="true"
                    dateFormat="dd/mm/yy"
                    (onSelect)="onStartDateChange($event)"
                    class="w-full" />
            </div>

            <!-- Filtro por Data Fim -->
            <div>
                <label for="endDateFilter" class="block text-sm font-medium mb-2">Data Fim</label>
                <p-datepicker 
                    id="endDateFilter"
                    [(ngModel)]="endDate"
                    placeholder="Selecione a data fim"
                    [showClear]="true"
                    dateFormat="dd/mm/yy"
                    (onSelect)="onEndDateChange($event)"
                    class="w-full" />
            </div>
        </div>
    </div>

    <p-table 
        [value]="rides" 
        [paginator]="true" 
        [rows]="10" 
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} corridas"
        [tableStyle]="{'min-width': '50rem'}"
        styleClass="p-datatable-striped">
        
        <ng-template #header>
            <tr>
                <th style="width:8%">ID</th>
                <th style="width:15%">Data</th>
                <th style="width:20%">Motorista</th>
                <th style="width:15%">Origem</th>
                <th style="width:15%">Destino</th>
                <th style="width:10%">Assentos</th>
                <th style="width:10%">Status</th>
                <th style="width:17%">Ações</th>
            </tr>
        </ng-template>
        
        <ng-template #body let-ride>
            <tr>
                <td>{{ ride.id }}</td>
                <td>{{ formatDate(ride.date) }}</td>
                <td>{{ ride.driverName }}</td>
                <td>{{ ride.fromCityName }}</td>
                <td>{{ ride.toCityName }}</td>
                <td>{{ ride.seatCount }}</td>
                <td>
                    <p-tag 
                        [value]="ride.status" 
                        [severity]="getStatusSeverity(ride.status)"
                        [rounded]="true" />
                </td>
                <td>
                    <div class="flex gap-2">
                        <p-button 
                            icon="pi pi-users" 
                            severity="secondary" 
                            size="small"
                            (onClick)="showRideClients(ride.id)"
                            pTooltip="Ver Clientes" />
                        <p-button 
                            icon="pi pi-pencil" 
                            severity="info" 
                            size="small"
                            (onClick)="editRide(ride.id)"
                            pTooltip="Editar" />
                        <p-button 
                            icon="pi pi-trash" 
                            severity="danger" 
                            size="small"
                            (onClick)="deleteRide(ride.id)"
                            pTooltip="Excluir" />
                    </div>
                </td>
            </tr>
        </ng-template>
        
        <ng-template #empty>
            <tr>
                <td colspan="8" class="text-center py-4">
                    Nenhuma corrida encontrada.
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Modal para exibir clientes da corrida -->
<p-dialog 
    header="Clientes da Viagem" 
    [(visible)]="clientsModalVisible" 
    [modal]="true" 
    [style]="{width: '50vw'}"
    [closable]="true">
    
    <div class="mb-4">
        <div class="flex justify-between items-center mb-3">
            <h3 class="text-lg font-semibold">Clientes Vinculados</h3>
            <p-button 
                label="Adicionar" 
                icon="pi pi-plus" 
                severity="success" 
                size="small"
                (onClick)="showAddClientDialog()" />
        </div>
        
        <p-table 
            [value]="rideClients" 
            [paginator]="true" 
            [rows]="5"
            [tableStyle]="{'min-width': '40rem'}"
            styleClass="p-datatable-striped">
            
            <ng-template #header>
                <tr>
                    <th>ID</th>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Ações</th>
                </tr>
            </ng-template>
            
            <ng-template #body let-client>
                <tr>
                    <td>{{ client.id }}</td>
                    <td>{{ client.name }}</td>
                    <td>{{ client.email }}</td>
                    <td>
                        <p-button 
                            icon="pi pi-trash" 
                            severity="danger" 
                            size="small"
                            (onClick)="removeClientFromRide(client.id)"
                            pTooltip="Remover Cliente" />
                    </td>
                </tr>
            </ng-template>
            
            <ng-template #empty>
                <tr>
                    <td colspan="4" class="text-center py-4">
                        Nenhum cliente vinculado a esta corrida.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>

<!-- Modal para adicionar cliente -->
<p-dialog 
    header="Adicionar Cliente à Corrida" 
    [(visible)]="addClientModalVisible" 
    [modal]="true" 
    [style]="{width: '50vw'}"
    [closable]="true">
    
    <div class="space-y-4">
        <!-- Informações do Cliente -->
        <div class="mb-4">
            <label for="clientSelect" class="block text-sm font-medium mb-2">Selecionar Cliente:</label>
            <p-select
                id="clientSelect"
                [(ngModel)]="selectedClientId"
                [options]="availableClients"
                optionLabel="name"
                optionValue="id"
                placeholder="Escolha um cliente"
                [showClear]="true"
                class="w-full"
                (onChange)="onClientSelected()">
                <ng-template let-client pTemplate="item">
                    <div>{{ client.name }} - {{ client.email }}</div>
                </ng-template>
            </p-select>
        </div>

        <!-- Endereço de Origem -->
        <div class="border-t pt-4">
            <h4 class="text-lg font-semibold mb-3 text-blue-600">Endereço de Origem</h4>
            
            <!-- Opção de modo de entrada -->
            <div class="mb-3">
                <div class="flex align-items-center gap-3">
                    <div class="flex align-items-center">
                        <input 
                            type="radio" 
                            id="useExistingFrom"
                            [checked]="useExistingFromAddress"
                            (change)="useExistingFromAddress = true; onFromAddressModeChange()"
                            [disabled]="selectedClientAddresses.length === 0"
                            class="mr-2" />
                        <label for="useExistingFrom" class="cursor-pointer">Usar endereço existente</label>
                    </div>
                    <div class="flex align-items-center">
                        <input 
                            type="radio" 
                            id="useManualFrom"
                            [checked]="!useExistingFromAddress"
                            (change)="useExistingFromAddress = false; onFromAddressModeChange()"
                            class="mr-2" />
                        <label for="useManualFrom" class="cursor-pointer">Inserir manualmente</label>
                    </div>
                </div>
            </div>
            
            <!-- Seleção de endereço existente -->
            <div *ngIf="useExistingFromAddress && selectedClientAddresses.length > 0" class="mb-4">
                <label for="fromAddressSelect" class="block text-sm font-medium mb-2">Selecionar Endereço:</label>
                <p-select
                    id="fromAddressSelect"
                    [(ngModel)]="selectedFromAddressIndex"
                    [options]="getAddressOptions()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione um endereço"
                    class="w-full"
                    (onChange)="onFromAddressSelected()" />
            </div>
            
            <!-- Campos de formulário manual -->
            <div *ngIf="!useExistingFromAddress" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="originStreet" class="block text-sm font-medium mb-1">Rua/Avenida:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="originStreet"
                        [(ngModel)]="clientAddress.fromAddress.addressName"
                        placeholder="Nome da rua ou avenida"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="originNumber" class="block text-sm font-medium mb-1">Número:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="originNumber"
                        [(ngModel)]="clientAddress.fromAddress.number"
                        placeholder="Número"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="originNeighborhood" class="block text-sm font-medium mb-1">Bairro:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="originNeighborhood"
                        [(ngModel)]="clientAddress.fromAddress.district"
                        placeholder="Nome do bairro"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="originCity" class="block text-sm font-medium mb-1">Cidade:</label>
                    <p-select
                        id="originCity"
                        [(ngModel)]="clientAddress.fromAddress.cityId"
                        [options]="modalFromCities"
                        optionLabel="displayName"
                        optionValue="id"
                        placeholder="Selecione a cidade"
                        [filter]="true"
                        [showClear]="true"
                        [loading]="isLoadingModalFromCities"
                        (onFilter)="onModalFromCityFilter($event)"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="originZipCode" class="block text-sm font-medium mb-1">CEP:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="originZipCode"
                        [(ngModel)]="clientAddress.fromAddress.zipCode"
                        placeholder="00000-000"
                        class="w-full" />
                </div>
            </div>
        </div>

        <!-- Endereço de Destino -->
        <div class="border-t pt-4">
            <h4 class="text-lg font-semibold mb-3 text-green-600">Endereço de Destino</h4>
            
            <!-- Opção de modo de entrada -->
            <div class="mb-3">
                <div class="flex align-items-center gap-3">
                    <div class="flex align-items-center">
                        <input 
                            type="radio" 
                            id="useExistingTo"
                            [checked]="useExistingToAddress"
                            (change)="useExistingToAddress = true; onToAddressModeChange()"
                            [disabled]="selectedClientAddresses.length === 0"
                            class="mr-2" />
                        <label for="useExistingTo" class="cursor-pointer">Usar endereço existente</label>
                    </div>
                    <div class="flex align-items-center">
                        <input 
                            type="radio" 
                            id="useManualTo"
                            [checked]="!useExistingToAddress"
                            (change)="useExistingToAddress = false; onToAddressModeChange()"
                            class="mr-2" />
                        <label for="useManualTo" class="cursor-pointer">Inserir manualmente</label>
                    </div>
                </div>
            </div>
            
            <!-- Seleção de endereço existente -->
            <div *ngIf="useExistingToAddress && selectedClientAddresses.length > 0" class="mb-4">
                <label for="toAddressSelect" class="block text-sm font-medium mb-2">Selecionar Endereço:</label>
                <p-select
                    id="toAddressSelect"
                    [(ngModel)]="selectedToAddressIndex"
                    [options]="getAddressOptions()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione um endereço"
                    class="w-full"
                    (onChange)="onToAddressSelected()" />
            </div>
            
            <!-- Campos de formulário manual -->
            <div *ngIf="!useExistingToAddress" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="destinationStreet" class="block text-sm font-medium mb-1">Rua/Avenida:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="destinationStreet"
                        [(ngModel)]="clientAddress.toAddress.addressName"
                        placeholder="Nome da rua ou avenida"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="destinationNumber" class="block text-sm font-medium mb-1">Número:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="destinationNumber"
                        [(ngModel)]="clientAddress.toAddress.number"
                        placeholder="Número"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="destinationNeighborhood" class="block text-sm font-medium mb-1">Bairro:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="destinationNeighborhood"
                        [(ngModel)]="clientAddress.toAddress.district"
                        placeholder="Nome do bairro"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="destinationCity" class="block text-sm font-medium mb-1">Cidade:</label>
                    <p-select
                        id="destinationCity"
                        [(ngModel)]="clientAddress.toAddress.cityId"
                        [options]="modalToCities"
                        optionLabel="displayName"
                        optionValue="id"
                        placeholder="Selecione a cidade"
                        [filter]="true"
                        [showClear]="true"
                        [loading]="isLoadingModalToCities"
                        (onFilter)="onModalToCityFilter($event)"
                        class="w-full" />
                </div>
                
                <div>
                    <label for="destinationZipCode" class="block text-sm font-medium mb-1">CEP:</label>
                    <input 
                        type="text" 
                        pInputText
                        id="destinationZipCode"
                        [(ngModel)]="clientAddress.toAddress.zipCode"
                        placeholder="00000-000"
                        class="w-full" />
                </div>
            </div>
        </div>
    </div>
    
    <div class="flex justify-end gap-2 mt-6">
        <p-button 
            label="Cancelar" 
            severity="secondary" 
            (onClick)="cancelAddClient()" />
        <p-button 
            label="Adicionar Cliente" 
            severity="success" 
            (onClick)="addClientToRide()"
            [disabled]="!isFormValid()" />
    </div>
</p-dialog>
